import { z } from "zod";
import {
  useWidgetViewState,
  type WidgetModule,
  type WidgetRenderContext,
} from "@salestrak/ui";
import { IssueViewCustomFields } from "#app/components/issue-view/issue-view-custom-fields";
import { useIssueWidgetContext } from "#app/widgets/issue/issue-widget-context";
import { IssueCustomFieldsHeaderActions } from "./header-actions";

export const issueCustomFieldsConfigSchema = z.looseObject({});
export type IssueCustomFieldsConfig = z.infer<typeof issueCustomFieldsConfigSchema>;

function IssueCustomFieldsRender(_: WidgetRenderContext<IssueCustomFieldsConfig>) {
  const ctx = useIssueWidgetContext();
  const { state } = useWidgetViewState();
  const search = typeof state.search === "string" ? state.search : "";
  return (
    <IssueViewCustomFields
      issue={ctx.issue}
      values={ctx.values}
      customFields={ctx.customFields}
      orderedTypeFieldIds={ctx.orderedTypeFieldIds}
      onUpdateValue={ctx.onUpdateValue}
      onAddPhoto={ctx.onAddPhoto}
      onRemovePhoto={ctx.onRemovePhoto}
      requiredFieldIds={ctx.requiredFieldIds}
      onCloseIssue={ctx.onCloseIssue}
      focusCustomFieldId={ctx.focusCustomFieldId}
      hideHeader
      search={search}
    />
  );
}

export const issueCustomFieldsDef: WidgetModule<IssueCustomFieldsConfig> = {
  type: "issue-custom-fields",
  title: "Custom fields",
  icon: "list",
  span: { minW: 3, minH: 1, maxW: 12, maxH: 12, defaultW: 12, defaultH: 4 },
  configSchema: issueCustomFieldsConfigSchema,
  headerActions: IssueCustomFieldsHeaderActions,
  render: IssueCustomFieldsRender,
};
